// extracted by css-extract-rspack-plugin
export default {"Box":"TableOfContentsPanel-module__Box__R_eoruK","NavList":"TableOfContentsPanel-module__NavList__YnX5AKz"};